import { toTitleCase } from '../helpers/stringHelper'
import { addTrailingSlash } from './addTrailingSlash'
import { removeLocaleFromPathname } from './removeLocaleFromPathname'
import { removeDuplicateLocaleFromPathname } from './removeLocaleFromPathname'

/**
 * Generate JSON-LD schema for breadcrumbs
 *
 * @param {string} pathname
 * @param {string} websiteURL - Should include locale, if used.
 * @param {string | undefined} title
 * @param {Function} pageExists - Page existence check function.
 * @returns {object | null}
 */
export const generateBreadcrumbJsonLd = (
  pathname,
  websiteURL,
  title,
  pageExist
) => {
  if (
    typeof pathname !== 'string' ||
    typeof websiteURL !== 'string' ||
    typeof pageExist !== 'function'
  ) {
    return null
  }

  websiteURL = removeDuplicateLocaleFromPathname(websiteURL)
  websiteURL = addTrailingSlash(websiteURL)

  const pathnameNoLocale = removeLocaleFromPathname(pathname)
  const pathSegments = pathnameNoLocale.split('/').filter(Boolean)

  let position = 1

  const itemListElement = pathSegments.reduce(
    (acc, segment, index) => {
      const currentPathname = pathSegments.slice(0, index + 1).join('/')
      const pathExist = pageExist('/' + currentPathname + '/')

      if (!pathExist) {
        return acc
      }

      position++

      const url = `${websiteURL}${currentPathname}/`
      const name =
        (index === pathSegments.length - 1 && title) ||
        toTitleCase(segment.replace(/-/g, ' '))

      acc.push({
        '@type': 'ListItem',
        position: position,
        name: name,
        item: url,
      })

      return acc
    },
    [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: websiteURL,
      },
    ]
  )

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: itemListElement,
  }
}
